'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildWidgetDataFromSettings = exports.buildSettingsWidgetDataFromSettings = exports.getStagedChangesCount = exports.getUserSettings = exports.getStagedPortalSettings = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reselect = require('reselect');

var _messageSelectors = require('conversations-core/selectors/messageSelectors');

var _userSelectors = require('conversations-core/selectors/userSelectors');

var _color = require('conversations-core/utils/color');

var _avatar = require('conversations-core/utils/avatar');

var _Responder = require('conversations-schema/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

var _Message = require('conversations-schema/records/Message');

var _Message2 = _interopRequireDefault(_Message);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStagedPortalSettings = exports.getStagedPortalSettings = (0, _getIn2.default)(['portalSettings', 'stagedSettings']);

var getPortalSettings = (0, _getIn2.default)(['portalSettings', 'serverSettings']);

var getStagedUserSettings = (0, _getIn2.default)(['userSettings', 'stagedSettings']);

var getUserSettings = exports.getUserSettings = (0, _getIn2.default)(['userSettings', 'serverSettings']);

function buildDefaultMessage() {
  var defaultMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Message2.default();

  return defaultMessage.set('initialMessage', _I18n2.default.text('default.initialMessage'));
}

function buildMessageRecord(editMessage) {
  var defaultMessage = new _Message2.default();

  if (defaultMessage !== editMessage) {
    return editMessage;
  }

  return buildDefaultMessage();
}

function buildResponderRecord(authUser) {
  var email = authUser.get('email');
  return new _Responder2.default({
    online: true,
    avatar: (0, _avatar.getHubSettingsAvatar)(email),
    firstName: authUser.get('first_name'),
    lastName: authUser.get('last_name'),
    userId: authUser.get('user_id'),
    email: email
  });
}

var getStagedChangesCount = exports.getStagedChangesCount = (0, _reselect.createSelector)([getStagedUserSettings, getUserSettings, getStagedPortalSettings, getPortalSettings], function (stagedUserSettings, userSettings, stagedPortalSettings, portalSettings) {
  var userSettingsCount = userSettings.toMap().reduce(function (acc, value, key) {
    if (stagedUserSettings.get(key) !== value) {
      return acc + 1;
    }
    return acc;
  }, 0);

  var portalSettingsCount = portalSettings.toMap().reduce(function (acc, value, key) {
    if (stagedPortalSettings.get(key) !== value) {
      return acc + 1;
    }
    return acc;
  }, 0);
  return userSettingsCount + portalSettingsCount;
});

var buildSettingsWidgetDataFromSettings = exports.buildSettingsWidgetDataFromSettings = (0, _reselect.createSelector)([getStagedPortalSettings, getStagedUserSettings, _userSelectors.getUser], function (portalSettings, userSettings, authUser, awayMessage) {
  return new _WidgetData2.default({
    message: buildDefaultMessage(),
    responder: buildResponderRecord(authUser),
    aboutMe: userSettings.aboutMe,
    jobTitle: userSettings.jobTitle,
    launcherType: portalSettings.launcherType,
    coloring: (0, _color.buildColorRecord)(portalSettings.accentColor),
    meetingsLinkText: userSettings.meetingsLinkText,
    customAwayMessage: awayMessage,
    showingHsBranding: portalSettings.showingHsBranding
  });
});

var buildWidgetDataFromSettings = exports.buildWidgetDataFromSettings = (0, _reselect.createSelector)([getStagedPortalSettings, getStagedUserSettings, _messageSelectors.getStagedMessage, _userSelectors.getUser, _messageSelectors.getAwayMessage], function (portalSettings, userSettings, editMessage, authUser, awayMessage) {
  return new _WidgetData2.default({
    message: buildMessageRecord(editMessage),
    responder: buildResponderRecord(authUser),
    aboutMe: userSettings.aboutMe,
    jobTitle: userSettings.jobTitle,
    launcherType: portalSettings.launcherType,
    coloring: (0, _color.buildColorRecord)(portalSettings.accentColor),
    meetingsLinkText: userSettings.meetingsLinkText,
    customAwayMessage: awayMessage,
    showingHsBranding: portalSettings.showingHsBranding
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/settingsSelectors.js
// module id = 522
// module chunks = 0